<template>
    <div class="container-fluid layout-wrapper">
        <div class="row">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header admin-header w-100">
                        <h1 class="text-accent-light">زیر آیتم ها</h1>
                        <button class="btn btn-link text-accent-light" @click="onAddStyleClicked">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 mb-3">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">آیتم اصلی</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                               :data="mainItems" :mode="'create'"
                                               :header="{multiple: false, label: 'title'}"
                                               aria-placeholder="آیتم اصلی"
                                               @onChange="onCompetitionFieldChange">

                                    </vs-select>
                                    <!--                                        <input class="form-control" v-model="model.competitionFieldName">-->
                                </div>

                            </div>

                        </div>
                        <div class="row">
                            <no-item-alert v-if="subItems.length === 0 && !isLoading"/>
                            <preloader v-if="isLoading"/>
                            <!--                            v-for="item in subItems"-->
                            <div class="col-lg-4 mt-3" v-for="item in subItems">
                                <div class="card style shadow">
                                    <div class="d-flex align-items-center">
                                        <div class="field-image-container">
                                            <!--<div class="field-image"                                                 style="background:'../../../public/img/subItem.png'}"></div>-->
                                            <img src="../../../public/img/subItem.png" class="img-fluid pr-3">
                                            <button class="btn btn-link" @click="onDeleteStyleClicked(item.id)"><i
                                                    class="fa fa-trash-o"></i></button>
                                        </div>
                                        <div class="style-container clickable">
                                            <h4 class="mb-0">{{item.title}}</h4>
                                            <small>{{item.typeName}}</small>
                                            <i v-if="item.showInPreview" class="fa fa-eye px-3"
                                               title="نمایش در پیش نمایش سایت"></i>
                                            <i v-else class="fa fa-eye-slash px-3"
                                               title="عدم نمایش در پیش نمایش سایت"></i>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <modal show="false" ref="insertModal">
                        <div class="container">
                            <div class="row">
                                <div class="col-12 text-center">
                                    <h1 v-if="mode === 'create'">ایجاد زیر آیتم</h1>
                                    <h1 v-else>ویرایش زیر آیتم</h1>
                                </div>
                                <div class="col-lg-6 offset-lg-3 mb-4">
                                    <div class="input-group round">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">آیتم اصلی</span>
                                        </div>
                                        <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                                   :data="mainItems" :mode="'create'"
                                                   :selected-val="id"
                                                   :header="{multiple: false, label: 'title'}"
                                                   aria-placeholder="آیتم اصلی"
                                                   @onChange="onAddCompetitionFieldChange">

                                        </vs-select>
                                    </div>
                                </div>
                                <div class="col-lg-6 offset-lg-3 mb-4">
                                    <div class="input-group round">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">نام زیر آیتم</span>
                                        </div>
                                        <input class="form-control" v-model="model.title">
                                    </div>
                                    <div class="input-group round m-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">نوع داده</span>
                                        </div>
                                        <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                                   :data="subItemsType" :mode="'create'"
                                                   :selected-val="value"
                                                   :header="{multiple: false, label: 'title'}"
                                                   aria-placeholder="نوع داده"
                                                   @onChange="onAddCompetitionTypeChange">

                                        </vs-select>
                                    </div>
                                    <div class="input-group round m-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">نمایش در پیش نمایش</span>
                                        </div>
                                        <input class="form-control" type="checkbox" v-model="model.showInPreview">
                                    </div>
                                </div>
                                <div class="col-lg-6 offset-lg-3 text-center">
                                    <!--<input type="file" class="d-none" id="banner" @change="onFieldBannerChanged">
                                    <img :src="validateImage(model.sportBannerAddress)" class="img-fluid shadow" id="bannerImg">-->
                                    <label class="btn btn-primary btn-round clickable mt-3"
                                           @click="createCompetitionStyle">ایجاد زیر آیتم</label>
                                </div>
                            </div>
                        </div>
                    </modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import * as $ from "jquery";
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";

    export default {
        name: "subItems",
        components: {VsSelect},
        data() {
            return {
                mainItems: [],
                subItems: [],
                subItemsType: [],
                mode: 'create',
                model: {
                    id: 0,
                    title: "",
                    type: 1,
                    showInPreview: false,
                    mainItemId: 0
                },
                preselectedCompetitionField: {},
                preselectedField: {},
                isLoading: false,
                selectedMain:0,
            }
        },
        mounted() {
            this.getmainItems();
            this.getsubItems();
            this.getsubItemsType();

        },
        methods: {
            getsubItemsType() {
                new BaseService("Rezome", "/GetEnSubItemType").getList().then(response => {
                    this.subItemsType = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                })
            },
            getmainItems() {
                new BaseService("Rezome", "/GetMainitems").getList().then(response => {
                    this.mainItems = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                })
            },
            getsubItems(fieldId = null) {
                let query = {};
                if (fieldId !== null) {
                    query.id = fieldId;
                    new BaseService("Rezome", '/GetSubItemByid').getList(query).then(response => {
                        this.subItems = response.data;
                        for (const s of this.subItems) {
                            for (let t of this.subItemsType) {
                                if (t.value === s.type) {
                                    s.typeName = t.title;
                                    break;
                                }
                            }
                        }
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    })
                }
            },
            onAddStyleClicked() {
                this.$refs.insertModal.showModal();
            },
            onCompetitionFieldChange(val) {
                if (val) {
                    this.selectedMain = val.id
                    this.getsubItems(val.id)
                }
            },
            onAddCompetitionFieldChange(val) {
                if (val) {
                    this.model.mainItemId = val.id
                }
            },
            onAddCompetitionTypeChange(val) {
                if (val) {
                    this.model.type = val.value
                }
            },
            onDeleteStyleClicked(id) {
                if (confirm("آیا از حذف آیتم اطمینان دارید؟")) {
                    this.isLoading = true;
                    new BaseService("Rezome", "DeleteSubItems").delete(id).then(response => {
                        this.isLoading = false;
                        this.$noty.success(response.data);
                        this.getsubItems(this.selectedMain);
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    })
                }
            },
            createCompetitionStyle() {
                new BaseService("Rezome", "/CreateSubItems").create(this.model).then(response => {
                    this.$refs.insertModal.hideModal();
                    this.$noty.success(response.data);
                    this.getsubItems(this.selectedMain);
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                })
            }

        }
    }
</script>

<style lang="scss" scoped>

</style>